import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning_yellow",
  "use": "warning_yellow-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"warning_yellow\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FC0\" cx=\"8\" cy=\"8\" r=\"8\" /><path fill=\"#333\" d=\"M9.07 10.302l.222-7.68H6.708l.209 7.68zM6.905 11.643h2.178v2.178H6.905z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id